<template>
  <div class="error-page">
    <AntProvider :theme="theme" :configProviderProps="{ locale: locale }">
      <div class="content">
        <Resource
          :src="
            getFeUrl(
              isChinese()
                ? '/youyan-platform/png/no-data.png'
                : '/rendora/404.png'
            )
          "
          :transform-resource="transformImage"
          class="mx-auto"
          :class="isChinese() ? 'w-[200px] h-[200px]' : 'w-[944px] h-[321px]'"
        />
        <div
          class="text-font-80 font-bold"
          :class="
            isChinese()
              ? 'text-[18px] my-[30px]'
              : 'text-[30px] mt-[15px] mb-[24px]'
          "
        >
          {{ $t('dang-qian-ye-mian-bu-cun-zai') }}
        </div>
        <span
          v-if="!isChinese()"
          class="w-[474px] block text-[#000] text-[17px] text-center mx-auto mb-[32px]"
        >
          The page you are looking for might have been removed had its name
          changed or is temporarily unavailabel.
        </span>
        <p class="text-text-1 mb-[32px]">
          {{ $t('n-miao-mei-fan-hui-shou-ye', [countdown]) }}
        </p>
        <a-button
          type="primary"
          :class="!isChinese() && 'w-[240px] h-[42px] rounded-[15px]'"
          @click="startToGoHome"
        >
          {{ $t('fan-hui-shou-ye') }}
        </a-button>
      </div>
    </AntProvider>
  </div>
</template>
<script lang="ts" setup>
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import enUS from 'ant-design-vue/es/locale/en_US'

import { AntProvider } from './features/provider'

const runtime = useRuntimeConfig()

const locale = ['CN', 'HK'].includes(runtime.public.area) ? zhCN : enUS

const theme = runtime.public.area === 'CN' ? 'light' : 'dark'
// const theme = 'light'

const props = defineProps({
  error: Object,
})

watchEffect(() => {
  console.error(props.error)
  console.error('error end')
})

let interval: NodeJS.Timeout
const countdown = ref(3)

onMounted(() => {
  interval = setInterval(() => {
    countdown.value--
    if (countdown.value <= 0) {
      startToGoHome()
    }
  }, 1000)
})

onBeforeUnmount(() => clearInterval(interval))

function startToGoHome() {
  clearInterval(interval)
  goHome()
}
</script>
<style lang="scss" scoped>
.error-page {
  padding-top: $top-height;
  height: calc(100vh - $top-height);

  .content {
    @apply flex flex-col justify-center h-full items-center mx-auto text-center;
  }
}
</style>
